import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import HVACHero from '../components/HVACLanding/HVACHero'
import SocialProof from '../components/HVACLanding/SocialProof'
import CampaignStrategy from '../components/HVACLanding/CampaignStrategy'
import WhyOLM from '../components/HVACLanding/WhyOLM'
import HowItWorks from '../components/HVACLanding/HowItWorks'
import FAQ from '../components/HVACLanding/FAQ'
import BookingSection from '../components/HVACLanding/BookingSection'
import Footer from '../components/Footer'

export default function HVAC({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <HVACHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />
            <Footer />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .hvac-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .hvac-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .hvac-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/hvac')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
